import { render, staticRenderFns } from "./AlertPop.vue?vue&type=template&id=70b175c4&"
import script from "./AlertPop.vue?vue&type=script&lang=js&"
export * from "./AlertPop.vue?vue&type=script&lang=js&"
import style0 from "./AlertPop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports